import { Alert, Card, Container, Button, Badge, Modal } from 'react-bootstrap';
import { connect, useSelector } from 'react-redux';
import { setIsLoading } from './general/actions';
import React, { useEffect, useState } from 'react';
import OrderSummary from './order/summary';
import axiosInstance from './general/axiosInstance';
import { Link } from 'react-router-dom';
import { currencyFormater } from './general/utils';
import { C, STATUS_COLORS, semaphoreColor } from './general/colors';
import Funds from './user/funds';

import AgreementList from './config/agreementList';

import infografiaImg from '../images/InfografiaCrearPedido.png';

const ROLE_CONFIG = {
  customer_order:    { label: 'Comprador',  icon: '🛒', color: C.primary  },
  customer_approver: { label: 'Aprobador',  icon: '✅', color: C.accent   },
  provider_approver: { label: 'Proveedor',  icon: '🚚', color: C.provider },
  default:           { label: 'Usuario',    icon: '👤', color: '#6b7280'  },
};

const WIDGETS = {
  customer_order: [
    { id: 'upcoming',     title: 'Entregas próximas',  subtitle: 'Próximos días', value: '0', detail: 'Sin entregas',   status: 'ok', icon: '📦' },
    { id: 'pending',      title: 'Pedidos por aprobar', subtitle: 'Por estado',    value: '0', detail: 'Sin pendientes', status: 'ok', icon: '🕒' },
    { id: 'period_spend', title: 'Mis fondos',          subtitle: 'Fondos',        value: '—', detail: 'Cargando…',      status: 'ok', icon: '💸' },
  ],
  customer_approver: [
    { id: 'upcoming',         title: 'Entregas próximas',   subtitle: 'Próximos días', value: '0', detail: 'Sin entregas',   status: 'ok', icon: '📦' },
    { id: 'pending_approval', title: 'Pedidos por aprobar', subtitle: 'Estado 1',      value: '0', detail: 'Sin pendientes', status: 'ok', icon: '🕒' },
    { id: 'period_spend',     title: 'Top 3 fondos con mas consumo',       subtitle: 'Fondos',        value: '—', detail: 'Cargando…',      status: 'ok', icon: '💸' },
  ],
  provider_approver: [
    { id: 'upcoming',         title: 'Entregas próximas',   subtitle: 'Próximos días', value: '0', detail: 'Sin entregas',   status: 'ok', icon: '📦' },
    { id: 'pending_approval', title: 'Pedidos por aprobar', subtitle: 'Estado 2',      value: '0', detail: 'Sin pendientes', status: 'ok', icon: '🕒' },
    { id: 'period_spend',     title: 'Top 3 fondos con mas consumo',       subtitle: 'Fondos',        value: '—', detail: 'Cargando…',      status: 'ok', icon: '💸' },
  ],
};

const FUND_LABEL_MAX = 200;

function SmallWidget({ w, color }) {
  const features = useSelector(state => state.features);
  const status = STATUS_COLORS[w.status] || STATUS_COLORS.ok;
  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 12, minHeight: 110, boxShadow: '0 6px 18px rgba(16,24,40,0.04)', fontFamily: "'DM Sans', 'Segoe UI', sans-serif'", display: 'flex', flexDirection: 'column' }}>
      <div style={{ height: 4, background: color, borderRadius: 6, marginBottom: 8 }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontWeight: 700 }}>{w.title}</div>
          <div style={{ color: '#6b7280', fontSize: 12 }}>{w.subtitle}</div>
        </div>
        {!w.hideValue && (
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 18, fontWeight: 800 }}>{w.value}</div>
            <div style={{ color: '#6b7280', fontSize: 12 }}>{w.detail}</div>
          </div>
        )}
      </div>
      {w.bars && w.bars.length > 0 ? (
        <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 5, flex: 1 }}>
          {w.bars.map((bar, i) => {
            const pct = Math.min(100, Math.max(0, bar.pct));
            const bc = semaphoreColor(pct, features);
            return (
              <div key={i}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#374151', marginBottom: 2 }}>
                  <span title={bar.label}>{bar.label.length > FUND_LABEL_MAX ? bar.label.slice(0, FUND_LABEL_MAX) + '…' : bar.label}</span>
                  <span style={{ color: bc, fontWeight: 700 }}>{pct.toFixed(0)}%</span>
                </div>
                <div style={{ background: '#e5e7eb', borderRadius: 999, height: 6, overflow: 'hidden' }}>
                  <div style={{ width: `${pct}%`, height: '100%', background: bc, borderRadius: 999, transition: 'width 0.4s ease' }} />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ marginTop: 8, display: 'flex', justifyContent: 'flex-start', gap: 8 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 10px', borderRadius: 999, background: status.bg, border: `1px solid ${status.border}`, color: status.text, fontWeight: 700, fontSize: 12 }}>
            <div style={{ width: 8, height: 8, borderRadius: 999, background: status.dot }} />
            <div>{w.status.toUpperCase()}</div>
          </div>
        </div>
      )}
      {w.onLink && (
        <div style={{ marginTop: 8, textAlign: 'right' }}>
          <button onClick={w.onLink} style={{ background: 'none', border: 'none', padding: 0, fontSize: 11, color: color, fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' }}>
            Ver todos <i className="fa fa-arrow-right" />
          </button>
        </div>
      )}
    </div>
  );
}

function Main(props) {

    const { organization_id, setIsLoading, roles, modules, userId, countPendingOrders } = props;

    const [orders, setOrders] = useState([]);
    const [funds, setFunds] = useState([]);
    const [lowestFunds, setLowestFunds] = useState([]);
    const [fundsShow, setFundsShow] = useState(false);
    const [orderStatuses, setOrderStatuses] = useState([]);

    const [hasEnableNotifications, setHasEnableNotifications] = useState(
        typeof Notification !== 'undefined' && Notification.permission === 'granted'
    );

    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('info');

    const [nextDaysFilter, setNextDaysFilter] = useState(parseInt(localStorage.nextDaysFilter) || 8);

    const getOrders = async () => {
        if (!organization_id) return;
        setIsLoading(true);
        try {
            const response = await axiosInstance.get('/orders/next-delivery/' + nextDaysFilter);
            setOrders(response.data);
            if (!response.data.length) {
                setMessageType('info');
                setMessage('No tiene pedidos para entrega en los proximos 7 días');
            } else {
                setMessage('');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    const fetchFunds = async () => {
        try {
            const response = await axiosInstance.get('/funds/current-user');
            setFunds(response.data || []);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchLowestFunds = async () => {
        try {
            const response = await axiosInstance.get('/users-funds/lowest-available');
            const data = response.data;
            setLowestFunds(Array.isArray(data) ? data : (data ? [data] : []));
        } catch (error) {
            console.log(error);
        }
    }

    const enableNotifications = () => {
        if (typeof Notification === 'undefined') return;
        if (Notification.permission === 'granted') { setHasEnableNotifications(true); return; }
        Notification.requestPermission().then(permission => setHasEnableNotifications(permission === 'granted'));
    };

    useEffect(() => {
        localStorage.nextDaysFilter = nextDaysFilter || '8';
        getOrders();
    }, [nextDaysFilter]);

    // initialize
    useEffect(() => {
        if (!organization_id || !roles.length) {
            let msg = '¡Bienvenido! ';
            if (!organization_id) {
                msg += 'Tu usuario aún no está asociado a ninguna entidad. ';
            } else if (!roles.length) {
                msg += 'Tu usuario esta pendiente de asignación de roles. ';
            }
            msg += 'Te recomendamos que te pongas en contacto con el administrador de tu entidad para resolver esta situación.';
            setMessage(msg);
            setMessageType('danger');
        }
        setNextDaysFilter(parseInt(localStorage.nextDaysFilter) || nextDaysFilter);

        if (roles.includes('customer_order')) fetchFunds();
        if (roles.includes('customer_approver') || roles.includes('provider_approver')) {
            axiosInstance.get('/order-statuses').then(r => setOrderStatuses(r.data || [])).catch(() => {});
            fetchLowestFunds();
        }
    }, []);

    const widgetRole = (() => {
        if (roles.includes('customer_approver')) return 'customer_approver';
        if (roles.includes('provider_approver')) return 'provider_approver';
        if (roles.includes('customer_order'))    return 'customer_order';
        return null;
    })();

    const roleConfig = ROLE_CONFIG[widgetRole] || ROLE_CONFIG.default;

  const [showInfographicModal, setShowInfographicModal] = useState(false);

    return (
        <Container>
        {organization_id == 1000 && (userId == 10 || userId == 22) ?
            <Card>
                <Alert variant={'danger'}>
                <b>
                    ¡Atención!{' '}
                    </b>

No hemos recibido el pago correspondiente a tu plan Pyme.
                </Alert>
                <Card.Footer align='start'>
                    <spam>

Es importante que realices el pago de manera inmediata para evitar interrupciones en tu servicio. Paga ahora desde Mercado pago {' '}
                    </spam>
                    <Button  variant={'success'} href='http://mpago.li/2K6u4RF' target='blank' >
                        Pagar ahora
                    </Button>
                </Card.Footer>
            </Card>
            :'' }
            <br></br>

            {/* Welcome banner */}
            <div style={{ borderRadius: 12, padding: 18, color: '#fff', background: roleConfig.color, marginBottom: 18, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
              <div>
                <div style={{ fontSize: 20, fontWeight: 800 }}>Hola, {props.username || 'Usuario'} 👋</div>
                <div style={{ opacity: 0.95, marginTop: 6 }}>{roleConfig.icon} Bienvenido al panel de {roleConfig.label}{props.organization && props.organization.name ? ' • ' + props.organization.name : ''}. Revisa tus tareas prioritarias abajo.</div>
              </div>
              <div style={{ textAlign: 'right', opacity: 0.95, flexShrink: 0 }}>
                <div style={{ fontSize: 13 }}>Entregas próximas</div>
                <div style={{ fontSize: 18, fontWeight: 800, marginTop: 6 }}>{orders.length}</div>
              </div>
            </div>

            {/* Widgets grid — solo para roles con widgets definidos */}
            {widgetRole && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, marginBottom: 18 }}>
                {WIDGETS[widgetRole].map((w) => {
                  let widget = w;

                  if (w.id === 'upcoming') {
                    const upcomingCount = orders.length;
                    const first = orders[0];
                    const nextDate = first
                      ? ((first.delivery_date || '') + (first.delivery_time ? ' ' + first.delivery_time : ''))
                      : '';
                    widget = {
                      ...w,
                      subtitle: `${nextDaysFilter} días`,
                      value: String(upcomingCount),
                      detail: upcomingCount && nextDate ? `Próxima: ${nextDate}` : (upcomingCount ? 'Próxima: fecha desconocida' : 'Sin entregas'),
                    };
                  }

                  if (widgetRole === 'customer_order' && w.id === 'pending') {
                    const s1 = orders.filter(o => o.order_status && o.order_status.id === 1).length;
                    const s2 = orders.filter(o => o.order_status && o.order_status.id === 2).length;
                    const total = s1 + s2;
                    widget = {
                      ...w,
                      value: String(total),
                      detail: total > 0 ? `Aprobar admin: ${s1} · Aprobar proveedor: ${s2}` : 'Sin pendientes',
                      status: total > 0 ? 'warning' : 'ok',
                    };
                  }

                  if ((widgetRole === 'customer_approver' || widgetRole === 'provider_approver') && w.id === 'pending_approval') {
                    const pendingStatusId = widgetRole === 'provider_approver' ? 2 : 1;
                    const statusDesc = orderStatuses.find(s => s.id === pendingStatusId)?.description || `Estado ${pendingStatusId}`;
                    widget = {
                      ...w,
                      subtitle: statusDesc,
                      value: String(countPendingOrders),
                      detail: countPendingOrders > 0 ? `${countPendingOrders} pedido${countPendingOrders > 1 ? 's' : ''} en espera` : 'Sin pendientes',
                      status: countPendingOrders > 0 ? 'warning' : 'ok',
                    };
                  }

                  if (widgetRole === 'customer_order' && w.id === 'period_spend') {
                    const active = funds.filter(f => f.is_active);
                    const totalSpent = active.reduce((acc, f) => acc + parseFloat(f.spent || 0), 0);
                    const allBars = active.map(f => ({
                      label: f.name || `Fondo ${f.id}`,
                      pct: f.amount > 0 ? (parseFloat(f.spent || 0) / parseFloat(f.amount)) * 100 : 0,
                    }));
                    const bars = allBars.slice(0, 2);
                    widget = {
                      ...w,
                      value: active.length ? currencyFormater(totalSpent) : '—',
                      detail: active.length ? `${active.length} fondo${active.length > 1 ? 's' : ''} activo${active.length > 1 ? 's' : ''}` : 'Sin fondos',
                      status: allBars.some(b => b.pct >= 80) ? 'warning' : 'ok',
                      bars,
                      onLink: () => setFundsShow(true),
                    };
                  }

                  if ((widgetRole === 'customer_approver' || widgetRole === 'provider_approver') && w.id === 'period_spend') {
                    const bars = lowestFunds.map(f => ({
                      label: f.name || `Fondo ${f.id}`,
                      pct: f.amount > 0 ? (parseFloat(f.spent || 0) / parseFloat(f.amount)) * 100 : 0,
                    }));
                    widget = {
                      ...w,
                      hideValue: true,
                      status: bars.some(b => b.pct >= 80) ? 'warning' : 'ok',
                      bars,
                    };
                  }

                  return <SmallWidget key={widget.id} w={widget} color={roleConfig.color} />;
                })}
              </div>
            )}

            {roles.includes('customer_order') && (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10, padding: '12px 16px', marginBottom: 16 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <i className="fa fa-info-circle" style={{ color: C.primary, fontSize: 18 }} />
                  <span style={{ fontSize: 13, color: '#1e40af', fontWeight: 500 }}>¿Quieres saber cómo hacer un pedido en ABI?</span>
                </div>
                <Button size="sm" variant="primary" onClick={() => setShowInfographicModal(true)}>
                  <i className="fa fa-image" style={{ marginRight: 6 }} />Ver infografía
                </Button>
              </div>
            )}

            {!hasEnableNotifications ?
                <Card>
                    <Alert variant={'info'}>
                        Te recomendamos habilitar las notificaciónes de Abi
                    </Alert>
                    <Card.Footer align='end'>
                        <Button onClick={enableNotifications}>
                            Habilitar Notificaciónes
                        </Button>
                    </Card.Footer>
                </Card>
                : ''}
            <br></br>
            {(roles.includes('provider_approver') || roles.includes('customer_approver')) && (
                <div className="order-section" style={{ marginBottom: 16 }}>
                    <div className="order-section-header" style={{ justifyContent: 'space-between' }}>
                        <span><i className="fa fa-tasks" /> Mis tareas</span>
                        <span style={{ fontSize: 11, fontWeight: 400, color: 'var(--abi-muted)', textTransform: 'none', letterSpacing: 0 }}>
                            <i className="fa fa-refresh" style={{ marginRight: 4 }} />Actualiza cada 3 min
                        </span>
                    </div>
                    <div className="order-section-body" style={{ padding: 0 }}>
                        {countPendingOrders > 0 ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 14, padding: '16px 20px', background: '#fffbeb', borderBottom: '1px solid #fde68a' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                                    <div style={{ width: 48, height: 48, borderRadius: 14, background: C.warning, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <i className="fa fa-clock-o" style={{ color: '#fff', fontSize: 22 }} />
                                    </div>
                                    <div>
                                        <div style={{ fontSize: 16, fontWeight: 800, color: '#92400e' }}>
                                            {countPendingOrders} pedido{countPendingOrders > 1 ? 's' : ''} pendiente{countPendingOrders > 1 ? 's' : ''} de aprobación
                                        </div>
                                        <div style={{ fontSize: 13, color: '#b45309', marginTop: 2 }}>
                                            Revísalos y apruébalos para continuar el flujo de entrega.
                                        </div>
                                    </div>
                                </div>
                                <Button as={Link} to="/order/approve" variant="warning" style={{ fontWeight: 700, whiteSpace: 'nowrap', flexShrink: 0 }}>
                                    <i className="fa fa-check-square-o" style={{ marginRight: 6 }} />
                                    Ir a aprobar
                                </Button>
                            </div>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '16px 20px' }}>
                                <div style={{ width: 48, height: 48, borderRadius: 14, background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <i className="fa fa-check" style={{ color: '#16a34a', fontSize: 22 }} />
                                </div>
                                <div>
                                    <div style={{ fontSize: 15, fontWeight: 700, color: '#166534' }}>¡Estás al día!</div>
                                    <div style={{ fontSize: 13, color: 'var(--abi-muted)', marginTop: 2 }}>No tienes pedidos pendientes por aprobar en este momento.</div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {/* ── Entregas próximas ── */}
            <div className="order-section" style={{ marginBottom: 16 }}>
                <div className="order-section-header" style={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <i className="fa fa-truck" /> Entregas próximas
                        {orders.length > 0 && (
                            <span style={{ background: 'var(--abi-primary)', color: '#fff', borderRadius: 999, fontSize: 10, fontWeight: 700, padding: '1px 7px' }}>
                                {orders.length}
                            </span>
                        )}
                    </span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>
                        <span style={{ fontSize: 11, color: 'var(--abi-muted)' }}>Ventana:</span>
                        <div style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid var(--abi-border)', borderRadius: 8, overflow: 'hidden', background: 'var(--abi-surface)' }}>
                            <button
                                onClick={() => setNextDaysFilter(v => Math.max(1, parseInt(v) - 1))}
                                style={{ background: 'none', border: 'none', padding: '2px 9px', cursor: 'pointer', color: 'var(--abi-primary)', fontSize: 13, fontWeight: 700, lineHeight: 1 }}
                            >−</button>
                            <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--abi-text)', padding: '2px 4px', borderLeft: '1px solid var(--abi-border)', borderRight: '1px solid var(--abi-border)', minWidth: 56, textAlign: 'center' }}>
                                {nextDaysFilter} días
                            </span>
                            <button
                                onClick={() => setNextDaysFilter(v => parseInt(v) + 1)}
                                style={{ background: 'none', border: 'none', padding: '2px 9px', cursor: 'pointer', color: 'var(--abi-primary)', fontSize: 13, fontWeight: 700, lineHeight: 1 }}
                            >+</button>
                        </div>
                    </div>
                </div>

                {message && !orders.length && (
                    <div style={{ padding: '40px 20px', textAlign: 'center', color: 'var(--abi-muted)' }}>
                        <i className="fa fa-truck" style={{ fontSize: 34, opacity: 0.18, display: 'block', marginBottom: 12 }} />
                        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4 }}>
                            Sin entregas en los próximos {nextDaysFilter} días
                        </div>
                        <div style={{ fontSize: 13 }}>
                            Usa los botones <strong>−</strong> / <strong>+</strong> para ampliar el período.
                        </div>
                    </div>
                )}

                <OrderSummary getOrders={getOrders} orders={orders} />
            </div>

            {/* ── Contratos de la entidad ── */}
            <div className="order-section">
                <div className="order-section-header">
                    <i className="fa fa-file-text-o" /> Contratos de la entidad
                </div>
                <div style={{ overflowX: 'auto' }}>
                    <AgreementList showProductsBtn={true} />
                </div>
            </div>

            <Funds show={fundsShow} setShow={setFundsShow} />

        <Modal show={showInfographicModal} onHide={() => setShowInfographicModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title><i className="fa fa-image" style={{ marginRight: 8 }} />Cómo crear un pedido en ABI</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: 0 }}>
            <img src={infografiaImg} alt="Infografía crear pedido" style={{ width: '100%', display: 'block' }} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => setShowInfographicModal(false)}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
        </Container>
    );
}

function mapStateToProps(state) {
    return {
        organization_id: state.organization_id,
        organization: state.organization || {},
        userId: state.userId,
        username: state.username,
        isLoggedIn: state.isLoggedIn,
        roles: state.roles,
        modules: state.modules,
        is_provider: state.is_provider,
        countPendingOrders: state.pendingCount || 0,
    };
}
const mapDispatchToProps = {
    setIsLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
